var _a, _b, _c;
import { __decorate, __metadata } from "tslib";
import ReportService from "@/core/services/ReportService";
import JwtService from "@/core/services/JwtService";
import { ReportActions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let AuthModule = class AuthModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = ReportActions.GET_REPORT_EXCEL](data) {
        return new Promise(resolve => {
            ReportService.post("Reports/GetReportsByProcedure_Excel_ByteArray", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_b = ReportActions.GET_REPORT_PDF](data) {
        return new Promise(resolve => {
            ReportService.post("Reports/GetReportsByProcedure_PDF_ByteArray", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_c = ReportActions.GET_REPORT_CSV](data) {
        return new Promise(resolve => {
            ReportService.post("Reports/GetReportsByProcedure_CSV_ByteArray", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AuthModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AuthModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AuthModule.prototype, _c, null);
AuthModule = __decorate([
    Module
], AuthModule);
export default AuthModule;
//# sourceMappingURL=ReportModule.js.map